var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pointer",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/purchase/banner.png")},on:{"click":_vm.$login}}),_c('text-left',{attrs:{"text-left":{
      height: 410,
      title: '提前规划您的采购费用支出',
      desc: '仪表盘汇总显示了系统内等待审核或等待支付的采购账单，帮助您更好的了解即将发生或者可能产生逾期的费用，提前规划您的采购费用支出。',
      textWidth: 800,
      left: false,
      imgWidth: 250,
      img: require('@/assets/purchase/img2.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 510,
      title: '创建重复采购账单',
      desc: '对于重复性的采购业务，筝鸣支持预设重复采购单。届时，系统会按照预设的计划自动创建采购单。同时，如果新建的采购单与历史采购单相似，只需复制一张历史采购账单，然后做一些数据修改即可。',
      textWidth: 680,
      left: true,
      imgWidth: 350,
      img: require('@/assets/purchase/img1.png')
    }}}),_c('part-list',{attrs:{"part-list":_vm.list}}),_c('Ready')],1)}
var staticRenderFns = []

export { render, staticRenderFns }